export default __webpack_public_path__ + "static/media/icon_facebook.13d3a213.svg";